export const CHAT_TIMEOUT = 4000;
